import React from "react";

import MDCircleIcon from "react-icons/lib/md/radio-button-unchecked";
import MDCheckCircleIcon from "react-icons/lib/md/radio-button-checked";

import { Box, Flex, Link, Text } from "src/components";
import { defaultPrevented } from "src/utils";
import { wrapIcon } from "src/icons";

import ValidationIcon from "./ValidationIcon";

const CircleIcon = wrapIcon(MDCircleIcon);
const CheckCircleIcon = wrapIcon(MDCheckCircleIcon);

const OptionButton = ({
  label,
  selected,
  onPress,
  color = "darkText",
  buttonStyle,
  numeric,
  Icon = selected ? CheckCircleIcon : CircleIcon,
}) => (
  <Link
    mr={2}
    mb={[2, 2, 2, 0]}
    to="#"
    onClick={defaultPrevented(onPress)}
    color={color}
    p={1}
    py={2}
    align="center"
    justify="center"
    textAlign="center"
    textDecoration="none"
  >
    <Flex align="center">
      <Icon size={22} />
      <Text
        fontSize={3}
        fontWeight="bold"
        color={color}
        numeric={numeric}
        ml={1}
      >
        {label}
      </Text>
    </Flex>
  </Link>
);

export default props => (
  <Flex
    mx={[0, 0, 3]}
    mt={2}
    mb={props.wrap ? 2 : [0, 0, 0, 3]}
    flex="1 0 auto"
    flexDirection={
      props.wrap ? "column" : ["column", "column", "column", "row"]
    }
    align={props.wrap ? undefined : ["stretch", "stretch", "stretch", "center"]}
    {...props.displayProps}
  >
    <Flex mr={3}>
      <Text fontWeight="semibold" mr={2}>
        {props.label}
      </Text>

      <ValidationIcon {...props} />
    </Flex>
    {props.renderHelpText({
      containerProps: {
        mt: 1,
        mb: 1,
      },
    })}
    <Flex
      flexDirection="row"
      flex={1}
      align={
        props.buttonStyle === "circle" ? ["center", "flex-start"] : ["stretch"]
      }
      mx={-2}
      my={props.wrap ? 2 : [2, 2, 2, 0]}
      style={{ flexWrap: "wrap" }}
    >
      {props.options.map(option => (
        <OptionButton
          key={option.value}
          color={option.color}
          label={option.label || option.value}
          onPress={e => {
            props.onTouch();
            props.setValue(option.value);
          }}
          selected={props.value === option.value}
          buttonStyle={props.buttonStyle}
          numeric={props.numeric}
        />
      ))}
    </Flex>
  </Flex>
);



// WEBPACK FOOTER //
// ./src/components/Form/OptionRadio.js